<template>
  <div class="countries-list">
    <page-header header="Countries" />

    <div class="mt-3">
      <search @input="updateSearchParam" class="mb-3" />

      <vue-good-table
        styleClass="vgt-table"
        :columns="columns"
        :rows="countries"
        @on-row-click="({ row }) => onRowClick(row)"
      />

      <pagination
        :data="pagination"
        :disabled="loading"
        @change-page="changePage"
      />
    </div>
  </div>
</template>

<script>
import {Vue, Component, Prop} from 'nuxt-property-decorator'
import { VueGoodTable } from 'vue-good-table'

import Search from '@/components/Search'
import Pagination from '@/components/Pagination'
import gateway from '@/gateway'
import {createHttpQuery} from '@/helpers'

const defaultParams = {
  page: 1,
  search: null,
}

@Component({
  components: {
    VueGoodTable,
    Search,
    Pagination,
  },
  metaInfo() {
    return {
      title: 'Countries',
    }
  },
})
export default class CountriesListView extends Vue {

  countries = []
  pagination = null
  params = defaultParams

  @Prop({default: false, type: Boolean}) loading

  @Prop({default: () => ([
    {
      label: 'Country',
      field: 'name',
    },
    {
      label: 'Last Updated',
      field: 'lastUpdated',
    },
    {
      label: '',
      field: () => ''
    },
  ])}) columns

  async getData() {
    const params = createHttpQuery(this.params)
    const [countriesResponse] = await Promise.all([
      gateway.get(`cms/engage/countries`, {params}),
    ])
    this.setData(countriesResponse.data)
  }

  created () {
    this.params = {
      ...this.params,
      ...this.$route.query,
    }
    this.getData()
  }

  setData(countries) {
    this.pagination = countries.meta
    this.countries = countries.data

    if (this.countries) {
      this.countries.forEach((company) => {
        company.showActions = false
      })
    }
  }

  changePage(page = 1) {
    if (this.params.page === page) return
    this.params.page = page
    const { params } = this
    history.pushState(
      {},
      null,
      this.$router.resolve({ query: { ...params, page: page.toString() } }).href
    )
    this.getData()
  }

  updateSearchParam(search = '') {
    if (this.params.search === search) return

    this.params.search = search
    this.params.page = 1
    const {params} = this
    history.pushState(
      {},
      null,
      this.$router.resolve({query: {...params}}).href
    )
    this.getData()
  }

  onRowClick(country) {
    this.$router.push({
      name: 'countries.edit',
      params: {
        slug: country.slug,
      },
    })
  }
}
</script>
